import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=2b1ed57a&scoped=true&lang=html&"
import script from "./TemplateSelector.vue?vue&type=script&lang=js&"
export * from "./TemplateSelector.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=2b1ed57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ed57a",
  null
  
)

export default component.exports